import { SVGProps, Ref, forwardRef } from 'react';

export const BookFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m7.3 3.012-.426-.143c-1.128-.377-2.258-.755-3.407-1.055C.448 1.024 0 1.578 0 5.19V8.1c0 3.815.5 4.502 4 5.49.96.27 1.938.475 2.914.68l.386.08z"
                fill="currentColor"
            />
            <path
                d="M8.7 14.35V3.012l.422-.141c.955-.32 1.91-.639 2.878-.912 3.5-.988 4-.584 4 3.232V8.1c0 3.815-.5 4.502-4 5.49-.961.27-1.937.475-2.913.68z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BookFilledSize16Glyph.displayName = 'BookFilledSize16Glyph';
